<template>
  <div class="body">
    <div class="head"></div>
    <div class="title">
      <img src="../assets/img/w_title.png" alt="" srcset="" />
    </div>
    <div class="news">
      <a href="http://www.thecover.cn/news/6314130" class="news-item">关于《中共四川省委关于制定四川省国民经济和社会发展第十四个五年规划和二〇三五年远景目标的建议》的说明</a>
      <a href="http://www.thecover.cn/news/6314127" class="news-item">中共四川省委关于制定四川省国民经济和社会发展第十四个五年规划和二〇三五年远景目标的建议</a>
    </div>
    <div class="content">
      <img src="../assets/img/w_list.png" class="list-title" alt="" srcset="" />
      <div class="more">
        <div class="list-main" v-for="(item, index) in list" :key="item.id">
          <div class="list-item">
            <div class="list-avatar" v-if="!(index % 2)">
              <img src="../assets/img/avatar.png" alt="" srcset="" />
              {{ item.info.name.substr(0, 1) }}**
            </div>
            <div
              class="list-intro"
              :class="index % 2 ? 'list-intro-right' : ''"
            >
              <p>{{ item.info.intro }}</p>
            </div>
            <div class="list-avatar" v-if="index % 2">
              <img src="../assets/img/avatar.png" alt="" srcset="" />
              {{ item.info.name.substr(0, 1) }}**
            </div>
          </div>
        </div>
      </div>
      <div class="list-more" v-if="isMore" @click="onMore">
        <span>查看更多建言</span>
        <div class="list-more-arrow">
          <img src="../assets/img/news_arrow.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONFIG from "@/utils/config";
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";

import { mapState, mapActions } from "vuex";

let isSubmit = false;
const rows = 10;

export default {
  name: "home",
  data() {
    return {
      swiperOptions: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 7 * 1000,
        },
      },
      list: [],
      page: 1,
      isMore: true,
      nav: null,
      info: {
        name: "",
        sex: "",
        age: "",
        intro: "",
      },
      required: "",
      framework: CONFIG.framework,
    };
  },
  computed: {
    ...mapState(["shareData", "aid", "userinfo", "isPlayAudio"]),
  },
  created() {
    this.getList();
  },
  mounted() {
    const _this = this;
    isSubmit = false;
    this.isMore = true;
    this.share();
    document.querySelector(".loading-wrap").style.display = "none";
    this.setPageLoadingAsync(false);
  },
  methods: {
    ...mapActions(["setPageLoadingAsync", "Toast"]),
    share() {
      COVER.share(this.shareData);
    },
    onNav(index) {
      this.nav = index;
      this.$nextTick(() => {
        window.scrollTo(0, 500);
        this.$refs.name.focus();
      });
    },
    async getList() {
      const oldList = this.list;
      const res = await this.$request("/vote", "get", {
        aid: this.aid,
        page: this.page,
        rows,
      });

      if (res.errno === 0) {
        const list = res.data.list || [];
        this.list = [...oldList, ...list];
        if (list.length !== rows) {
          this.isMore = false;
        }
      }
    },
    async onSubmit() {
      if (isSubmit) {
        return;
      }
      let info = this.info;
      info.type = this.framework[this.nav].name.replace('<br>', '');
      this.required = "";

      for (let x in info) {
        if (!info[x] && x !== "title") {
          this.required = x;
          this.Toast({
            text: "请填写完整信息~",
          });
          return;
        }
      }

      isSubmit = true;
      let sbt = setTimeout(() => {
        document.querySelector(".loading-wrap").style.display = "flex";
      }, 1500);
      const res = await this.$request("/apply", "post", {
        aid: this.aid,
        token: new Date().getTime().toString(36),
        info,
      });

      isSubmit = false;
      clearTimeout(sbt);
      document.querySelector(".loading-wrap").style.display = "none";

      if (res.errno === 0) {
        this.Toast({
          text: "提交成功",
        });
        this.nav = null;
        this.onReset();
        return;
      }
    },
    onReset() {
      this.required = "";
      this.info = {
        name: "",
        sex: "",
        age: "",
        intro: "",
      };
    },
    onMore() {
      this.page++;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  background: #f6f6f7 url("../assets/img/w_bg.png") bottom center no-repeat;
  min-height: 100vh;
  padding-bottom: 30px;
  .head {
    background: url("../assets/img/w_head.jpg") top center no-repeat;
    height: 250px;
  }
  .title {
    width: 100%;
    background: #c9231c;
    img {
      width: 660px;
      display: table;
      margin: 0 auto;
      padding: 8px 0;
    }
  }
  .news {
    background: #fffcf9;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    .news-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #444b51;
      text-decoration: none;
      line-height: 1.0em;
      &::before {
        content: ' ';
        width: 5px;
        height: 5px;
        border-radius: 5px;
        border: 1px solid #c9231c;
        flex-shrink: 0;
        margin-right: 3px;
      }
      &:first-child {
        margin-right: 20px;
      }
      &:hover {
        color: #c9231c;
      }
    }
  }
}
.content {
  width: 1160px;
  margin: 0 auto;
  font-size: 14px;
  color: #444b51;
  .list-title {
    width: 100%;
    margin-top: 30px;
  }
  .list {
    padding: 30px 0;
  }
  .list-more {
    border: 1px solid #c9231c;
    width: 160px;
    display: flex;
    border-radius: 5px;
    margin: 0 auto;
    text-decoration: none;
    font-size: 16px;
    &:hover {
      box-shadow: 0 0 20px rgba(#4c4633, .2);
    }
    span {
      width: 100%;
      display: table;
      text-align: center;
      padding: 5px 0;
      background: #fbf0cc;
      color: #444b51;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      line-height: 1.3em;
    }
    .list-more-arrow {
      width: 35px;
      background: #c9231c;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      img {
        width: 17px;
      }
    }
  }
}
.list-main {
  width: 580px;
  display: flex;
  justify-content: center;
}
.list-item {
  width: 550px;
  display: flex;
  justify-content: space-between;
  .list-avatar {
    width: 35px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    margin-top: 10px;
    img {
      width: 35px;
      height: 35px;
      margin-bottom: 5px;
    }
  }
  .list-intro {
    width: 485px;
    border-radius: 12px;
    background: #fffcf9;
    border: 1px solid #cabd90;
    line-height: 1.7em;
    padding: 10px 23px;
    box-sizing: border-box;
    overflow: hidden;
    align-items: center;
    &::before {
      content: " ";
      width: 0;
      height: 0;
      border-top: 12px solid transparent;
      border-right: 12px solid #cabd90;
      border-bottom: 12px solid transparent;
      border-left: 0;
      position: absolute;
      margin: 50px 0 0 -36px;
    }
    &.list-intro-right {
      &::before {
        transform: rotate(180deg);
        margin: 50px 0 0 460px;
      }
    }
  }
}
.more {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  .list-item {
    margin-bottom: 20px;
  }
  .list-intro {
    height: auto;
    &::before {
      margin-top: 10px;
    }
    &.list-intro-right {
      &::before {
        margin-top: 10px;
      }
    }
  }
}
.nav-notice {
  color: #c9231c;
  font-style: oblique;
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
}
.nav {
  display: flex;
  justify-content: space-around;
  padding: 30px 0;
  height: 320px;
  box-sizing: border-box;
  flex-wrap: wrap;
  .nav-item {
    width: 188px;
    height: 130px;
    background: url("../assets/img/w_nav.png");
    background-size: 100% 100%;
    display: flex;
    cursor: url('https://yunyingcdn.thecover.cn/o_1epkpse581rqg16dchcf3tc1nh4t.png'), auto;
    align-items: center;
    justify-content: center;
    padding-bottom: 12px;
    box-sizing: border-box;
    color: #444b51;
    font-size: 20px;
    margin-bottom: 30px;
    text-align: center;
    &:hover,
    &.hover {
      flex-shrink: 0;
      background: url("../assets/img/w_nav_hover.png") no-repeat;
      background-size: 100% 100%;
      flex-shrink: 0;
      margin-top: -10px;
      color: #c9231c;
    }
  }
}
.input {
  width: 980px;
  background: white;
  border-radius: 16px;
  height: 560px;
  margin: 30px auto 0 auto;
  box-shadow: 0 0 20px rgba(#000000, 0.08);
  .input-title {
    background: #c9231c;
    color: white;
    text-align: center;
    font-family: "宋体";
    font-size: 20px;
    font-style: oblique;
    padding: 5px 0;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    font-weight: bold;
  }
  .input-content {
    padding: 40px 50px;
  }
  .input-name {
    display: flex;
    justify-content: space-between;
  }
  .input-item {
    font-size: 15px;
    margin-bottom: 20px;
    i {
      font-style: normal;
      width: 66px;
      display: inline-block;
      text-align: right;
    }
    input,
    select,
    textarea {
      width: 180px;
      border: 1px solid #d7c9a0;
      border-radius: 4px;
      padding: 7px 10px;
      outline: 0;
      margin: 0 7px 0 13px;
      box-sizing: border-box;
    }
    span {
      color: #c9231c;
    }
  }
  button {
    width: 160px;
    height: 36px;
    color: white;
    background: #c9231c;
    border: 0;
    border-radius: 4px;
    margin-left: 80px;
    cursor: pointer;
  }
}
</style>